import {useDebugValue} from 'react';

import {getNoUndefValuesObject} from '../../../utils/object';

function useEvents(defaultEvents, ...otherEvents) {
    const specifiedEvents = otherEvents.reduce((accumulatedEvents, currentEvents) => ({
        ...accumulatedEvents,
        ...getNoUndefValuesObject(currentEvents)
    }), {});

    const events = {
        ...defaultEvents,
        ...specifiedEvents
    };

    const result = {
        events
    };

    useDebugValue(result);

    return result;
}

export {useEvents};
